export const viedoList = [
  {
    title: '铁路法宣传①',
    video: 'https://qiniu.terminal.laway.cn/%E9%93%81%E8%B7%AF%E6%B3%95%E5%AE%A3%E4%BC%A0%E2%91%A0.mp4',
    img: ['https://qiniu.terminal.laway.cn/%E9%93%81%E8%B7%AF%E6%B3%95%E5%AE%A3%E4%BC%A0%E2%91%A0.png'],
    date: "2021-03-22 14:37"
  },
  {
    title: '铁路法宣传②',
    video: 'https://qiniu.terminal.laway.cn/%E9%93%81%E8%B7%AF%E6%B3%95%E5%AE%A3%E4%BC%A0%E2%91%A1.mp4',
    img: ['https://qiniu.terminal.laway.cn/%E9%93%81%E8%B7%AF%E6%B3%95%E5%AE%A3%E4%BC%A0%E2%91%A1.png'],
    date: "2021-03-22 14:37"
  },
  {
    title: '铁路安全条例宣传①',
    video: 'https://qiniu.terminal.laway.cn/%E9%93%81%E8%B7%AF%E5%AE%89%E5%85%A8%E6%9D%A1%E4%BE%8B%E5%AE%A3%E4%BC%A0%E2%91%A0.mp4',
    img: ['https://qiniu.terminal.laway.cn/%E9%93%81%E8%B7%AF%E5%AE%89%E5%85%A8%E6%9D%A1%E4%BE%8B%E5%AE%A3%E4%BC%A0%E2%91%A0%E5%B0%81%E9%9D%A2.png'],
    date: "2021-03-22 14:37"
  },
  {
    title: '铁路安全条例宣传②',
    video: 'https://qiniu.terminal.laway.cn/%E9%93%81%E8%B7%AF%E5%AE%89%E5%85%A8%E6%9D%A1%E4%BE%8B%E5%AE%A3%E4%BC%A0%E2%91%A1.mp4',
    img: ['https://qiniu.terminal.laway.cn/%E9%93%81%E8%B7%AF%E5%AE%89%E5%85%A8%E6%9D%A1%E4%BE%8B%E5%AE%A3%E4%BC%A0%E2%91%A1.png'],
    date: "2021-03-22 14:37"
  },
  {
    title: '铁路安全条例宣传③',
    video: 'https://qiniu.terminal.laway.cn/%E9%93%81%E8%B7%AF%E5%AE%89%E5%85%A8%E6%9D%A1%E4%BE%8B%E5%AE%A3%E4%BC%A0%E2%91%A2.mp4',
    img: ['https://qiniu.terminal.laway.cn/%E9%93%81%E8%B7%AF%E5%AE%89%E5%85%A8%E6%9D%A1%E4%BE%8B%E5%AE%A3%E4%BC%A0%E2%91%A2.png'],
    date: "2021-03-22 14:37"
  },
  {
    title: '民法典宣传片①',
    video: 'https://qiniu.terminal.laway.cn/%E6%B0%91%E6%B3%95%E5%85%B8%E5%AE%A3%E4%BC%A0%E7%89%87%E2%91%A0.ts',
    img: ['https://qiniu.terminal.laway.cn/%E6%B0%91%E6%B3%95%E5%85%B8%E5%AE%A3%E4%BC%A0%E7%89%87%E2%91%A0%E5%B0%81%E9%9D%A2.png'],
    date: "2021-03-22 14:37"
  },
  {
    title: '民法典宣传片②',
    video: 'https://qiniu.terminal.laway.cn/%E6%B0%91%E6%B3%95%E5%85%B8%E5%AE%A3%E4%BC%A0%E7%89%87%E2%91%A1.mp4',
    img: ['https://qiniu.terminal.laway.cn/%E6%B0%91%E6%B3%95%E5%85%B8%E5%AE%A3%E4%BC%A02.png'],
    date: "2021-03-22 14:37"
  }
]